import { InstallDetection } from "../../../../../../apis/companySearch/marketPenetrationOverTime";
import {
  BaseDateChartData,
  SeriesInfo,
} from "../../../../../../components/charts/BaseDateDataChart/types";

const normalizeDateFormat = (dateString: string): string => {
  return dateString.split(" ")[0];
};

export const transformToChartData = (
  rawData: InstallDetection[],
  productNameMap?: Map<number, string>
): BaseDateChartData[] => {
  const dateMap: Record<string, SeriesInfo[]> = {};

  for (const item of rawData) {
    const productName =
      productNameMap?.get(item.productId) || `Product ${item.productId}`;

    const seriesItem: SeriesInfo = {
      name: productName,
      value: item.companyCount
        ? (item.companyCount / item.marketCount) * 100
        : 0,
      companyCount: item.companyCount || undefined,
    };

    const normalizedDate = normalizeDateFormat(item.monthStartDate);

    if (!dateMap[normalizedDate]) {
      dateMap[normalizedDate] = [];
    }

    dateMap[normalizedDate].push(seriesItem);
  }

  const chartData: BaseDateChartData[] = Object.entries(dateMap).map(
    ([date, series]) => ({
      date,
      series,
    })
  );

  const sortedChartData = chartData.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );

  const cumulativeValues: Record<string, number> = {};
  const cumulativeCounts: Record<string, number> = {};

  for (const dataPoint of sortedChartData) {
    for (const series of dataPoint.series) {
      if (cumulativeValues[series.name] === undefined) {
        cumulativeValues[series.name] = 0;
        cumulativeCounts[series.name] = 0;
      }

      cumulativeValues[series.name] += series.value;
      cumulativeCounts[series.name] += series.companyCount || 0;

      series.value = Number.parseFloat(
        cumulativeValues[series.name].toFixed(2)
      );
      series.companyCount = cumulativeCounts[series.name];
    }
  }

  return sortedChartData;
};
